import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const handleNavClick = () => {
    setIsMenuOpen(false);
  };
  const isActive = (path: string) => {
    return location.pathname === path ? 'text-blue-600 font-medium' : 'text-gray-600 hover:text-blue-600';
  };
  return <header className="sticky top-0 z-50 w-full bg-white shadow-sm" data-id="element-120">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="flex justify-between items-center py-4" data-id="element-122">
          <div className="flex items-center" data-id="element-123">
            <Link to="/" className="text-xl font-bold text-blue-600" data-id="element-124">
              ApplicantPass
            </Link>
          </div>

          {/* Desktop navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-125">
            <Link to="/features" className={`${isActive('/features')} transition-colors`} data-id="element-126">
              Features
            </Link>
            <Link to="/how-it-works" className={`${isActive('/how-it-works')} transition-colors`} data-id="element-127">
              How It Works
            </Link>
            <Link to="/testimonials" className={`${isActive('/testimonials')} transition-colors`} data-id="element-128">
              Testimonials
            </Link>
            <Link to="/pricing" className={`${isActive('/pricing')} transition-colors`} data-id="element-129">
              Pricing
            </Link>
          </nav>

          <div className="hidden md:flex items-center space-x-4" data-id="element-130">
            <Link to="/login" className="px-4 py-2 text-blue-600 hover:text-blue-700 transition-colors" data-id="element-131">
              Login
            </Link>
            <Link to="/contact" className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-132">
              Get Started
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-133">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 rounded-md text-gray-600 hover:text-gray-900 focus:outline-none" aria-label="Toggle menu" data-id="element-134">
              {isMenuOpen ? <XIcon size={24} data-id="element-135" /> : <MenuIcon size={24} data-id="element-136" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden bg-white border-t" data-id="element-137">
          <div className="container mx-auto px-4 pt-2 pb-4 space-y-3" data-id="element-138">
            <Link to="/features" onClick={handleNavClick} className="block py-2 text-gray-600 hover:text-blue-600 transition-colors" data-id="element-139">
              Features
            </Link>
            <Link to="/how-it-works" onClick={handleNavClick} className="block py-2 text-gray-600 hover:text-blue-600 transition-colors" data-id="element-140">
              How It Works
            </Link>
            <Link to="/testimonials" onClick={handleNavClick} className="block py-2 text-gray-600 hover:text-blue-600 transition-colors" data-id="element-141">
              Testimonials
            </Link>
            <Link to="/pricing" onClick={handleNavClick} className="block py-2 text-gray-600 hover:text-blue-600 transition-colors" data-id="element-142">
              Pricing
            </Link>
            <div className="pt-2 space-y-2" data-id="element-143">
              <Link to="/login" onClick={handleNavClick} className="block w-full py-2 text-center text-blue-600 hover:text-blue-700 transition-colors" data-id="element-144">
                Login
              </Link>
              <Link to="/contact" onClick={handleNavClick} className="block w-full py-2 text-center bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-145">
                Get Started
              </Link>
            </div>
          </div>
        </div>}
    </header>;
};